define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    function chain(items) {
        var result = $.Deferred();
        var total = items.length;
        var count = 0;
        var chainNext = function (x) {
            count++;
            if (count >= total) {
                result.resolve(x);
            }
            else {
                items[count]().then(chainNext, function (err) { return result.reject(err); });
            }
        };
        items[0]().then(chainNext, function (err) {
            result.reject(err);
        });
        return result.promise();
    }
    exports["default"] = chain;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/asyncChain.js
// module id = 79
// module chunks = 0